import {BasicEntity} from '../../framework/message/BasicEntity';
import {Currency} from './Currency';
import {Language} from './Language';
import {TranslatedEmb} from './TranslatedEmb';

export class Country extends BasicEntity {
code: string;
currencies: {[key: string]: Currency};
icon: string;
label: TranslatedEmb;
languages: {[key: string]: Language};
}

